const Style = `
  <style>
    .modal-wrapper {
      padding: 0 44px 44px 44px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .modal-title {
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 25px;
      margin: 0 0 25px 0;
    }

    .modal-description {
      font-size: 16px;
      margin: 0;
      line-height: 24px;
      letter-spacing: .32px;
    }

    .modal-image{
      margin-bottom: 32px;
    }

    @media screen and (max-width: 1024px) {
      .modal-title {
        font-size: 20px;
      }

      .modal-description {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: .28px;
      }
    }
  </style>
`;

export { Style };
